<template>
    <div class="Wizard">
        <q-card
            class="WizardCard"
            bordered
        >
            <q-card-section class="WizardHeader bg-primary text-white q-py-sm q-px-md">
                <div
                    v-if="config.steps && config.title"
                    class="text-subtitle2 text-weight-medium"
                >
                    {{ headerTitle }}
                </div>

                <div
                    v-else
                    class="row items-center justify-between"
                >
                    <div class="text-subtitle2 text-weight-medium">
                        {{ datasetName || '' }}
                    </div>
                    <QIcon
                        name="close"
                        color="white"
                        style="cursor: pointer;"
                        @click="handleExitNoConfig()"
                    />
                </div>
            </q-card-section>

            <q-separator />

            <q-card-section class="WizardBody">
                <RouterView v-slot="{ Component, route }">
                    <Transition
                        v-if="projectId"
                        name="main-router"
                        mode="out-in"
                    >
                        <component
                            v-bind="route.params"
                            :is="Component"
                            :key="projectId"
                            :projectId="projectId"
                            :datasetId="datasetId"
                            class="Screen"
                            @on-change-dataset-id="handleChangeDatasetId"
                        />
                    </Transition>
                </RouterView>
            </q-card-section>
        </q-card>

        <ModalRequest
            ref="exitDialog"
            :title="config.title"
            :text="$t('wizard.modals.cancel.text')"
            @on-accept="handleExit"
        />
    </div>
</template>

<script>
import { ModalRequest } from '@/components'

export default {
    name: 'WizardComponent',
    components: {
        ModalRequest,
    },
    provide() {
        return {
            Wizard: this,
        }
    },
    data() {
        return {
            store: {},
            projectId: undefined,
            datasetId: undefined,
            datasetName: undefined,
            booster: false,
            boosterTab: undefined,
        }
    },
    computed: {
        config() {
            const { config } = this.store
            return config || {}
        },
        step() {
            const { step, steps = [] } = this.config
            return steps.find((s) => s.name === step)
        },
        headerTitle() {
            const base = this.config?.title || ''
            const datasetName = this.$route?.query?.datasetName

            const isDatasetWizard = this.$route?.name === 'WizardDataset'
            const stepName = this.step?.name
            const shouldShowName = isDatasetWizard && (stepName === 'upload' || stepName === 'keys')

            if (!base) return datasetName || ''
            if (!shouldShowName || !datasetName) return base
            return `${base} - ${datasetName}`
        },
    },
    watch: {
        config: {
            handler() {
                this.emitHeaderChange()
            },
            deep: true,
            immediate: true,
        },
        step: {
            handler() {
                this.emitHeaderChange()
            },
            immediate: true,
        },
    },
    mounted() {
        const { projectId, processId } = this.$route.params
        this.projectId = projectId
        this.datasetId = processId
        this.checkBooster()
        this.datasetName = this.$route.query.datasetName
    },
    methods: {
        emitHeaderChange() {
            this.$emit('wizard-header-change', { config: this.config, step: this.step })
        },
        checkBooster() {
            if (this.$route.query.booster) {
                this.booster = true
                this.boosterTab = this.$route.query.booster
            }
        },

        handleChangeDatasetId(datasetId) {
            this.datasetId = datasetId
        },
        handleClickExit() {
            const { exitDialog } = this.$refs
            if (exitDialog) exitDialog.open()
        },
        handleExit() {
            this.config.exit()
        },
        handleExitNoConfig() {
            if (this.booster) {
                const map = {
                    OVERVIEW: 'ProcessOverview',
                    PREDICTION: 'ProcessPrediction',
                    IMPROVEMENT: 'ProcessSimulation',
                    ALERTS: 'ProcessAlerts',
                }
                const target = map[this.boosterTab] || 'ProcessOverview'
                this.$router.push({ name: target, params: { processId: this.datasetId } })
            } else {
                const { organizationId } = this.$route.params || {}
                this.$router.push({ name: 'Project', params: { organizationId, projectId: this.projectId } })
            }
        },
    },
}
</script>
<style scoped lang="scss">
.WizardHeader {
    min-height: unset;
}

.Screen {
    &:deep() {
        .q-stepper {
            background: transparent;
        }
        .q-stepper__tab {
            .q-stepper__dot {
                background: transparent;
                color: $secondary;
                border: 2px solid $secondary;
                width: 32px;
                height: 32px;
            }
            .q-icon {
                color: $secondary;
                font-size: 18px;
            }

            .q-stepper__title {
                font-size: 12px;
                line-height: 16px;
            }

            &--active, &--done {
                .q-stepper__dot {
                    background: $secondary;
                    color: $white;
                    border: 2px solid $white;
                }
                .q-icon {
                    color: $white;
                }
            }
        }
        // Fix scroll between steps in Firefox
        .q-stepper__content .q-panel.scroll {
            overflow: hidden;
        }
    }
}
</style>
